import Loading from 'components/Loading';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useLocation } from 'react-router-dom';
import { getCompany } from 'services/company.routes';
import queryString from "utils/queryString";
import CompanyTable from './CompanyTable';
import { toast } from 'react-toastify';

export default function Company() {
    const [loading, setLoading] = useState(false);
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [company, setCompany] = useState([]);
    const { state } = useLocation();

    useEffect(() => {
        setLoading(true);
        const query = {
            cursor: cursor === null ? null : cursor,
        }
        getCompany(queryString(query), false, (isOk, data) => {
            if (!isOk) {
                setLoading(false);
                return toast.error(data.message)
            } else {
                if (page !== 0) {
                    setCompany((prev) => ([...prev, ...data.data]));
                } else {
                    setCompany(data.data);
                }
                setLoading(false);
                setCursor(data.meta.next_cursor === null ? '' : data.meta.next_cursor);
                if (data.meta.next_cursor !== null)
                    return setHasMore(true);

                else return setHasMore(false)
            }
        })
    }, [page]);

    useEffect(() => {
        if (state) {
            setCompany((prev) => {
                const index = prev.findIndex(item => item.id === state.id);
                if (index !== -1) {
                    const updatedData = [...prev];
                    updatedData[index] = state;
                    return updatedData;
                } else {
                    return [state, ...prev];
                }
            });
        }
    }, [state]);
    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }
    return (
        <DashboardLayout>
            <Loading loading={loading} />
            <DashboardNavbar />
            <InfiniteScroll dataLength={company.length} next={fetchMoreData} hasMore={hasMore}>
                <CompanyTable data={company} />
            </InfiniteScroll>
        </DashboardLayout>
    )
}
